import React, { useEffect, useState } from "react";
import axios from "axios";
import { getBaseUrl } from "../../utils";
import Select from 'react-select';
import { useNavigate } from "react-router-dom";

const FormThree = ({ nextStep, handleFormData, values, prevStep }) => {
    // const FormOneSubmit = (e) => {
    //     e.preventDefault();
    //     nextStep();
    // };
    const baseUrl = getBaseUrl();
    const token = localStorage.getItem("userToken");

    const [profileData, setProfileData] = useState(null);
    const [classList, setclassList] = useState([]);


    async function fetchProfileData() {
        try {
            const response = await axios.get(baseUrl + "user_api/getProfileData", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data.status) {
                console.log("response--------->", response.data.results);
                setProfileData(response.data.results);
            } else {
                console.log("Failed to fetch profile data.");
            }
        } catch (error) {
            console.log("Error fetching profile data: " + error.message);
        } finally {
            //setLoading(false);
        }
    }

    async function classList_get() {
        try {
            const response = await axios.get(baseUrl + "user_api/classList", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data.status) {
                console.log("response----classList----->", response.data.results[4].education_type);
                setclassList(response.data.results);
            } else {
                console.log("Failed to fetch profile data.");
            }
        } catch (error) {
            console.log("Error fetching profile data: " + error.message);
        } finally {
            //setLoading(false);
        }
    }
    useEffect(() => {
        if (!token) {
            console.log("Token is missing. Please login again.");
            //setLoading(false);
            return;
        }
        fetchProfileData();
        classList_get();
    }, [token]);

    const [formData, setFormData] = useState({
        classId: "",
        qualification_name: "",
        category: "",
            qualification_completion_year: new Date().getFullYear().toString(),

        // qualification_completion_year: "",
    });

    useEffect(() => {
        if (profileData) {
            setFormData((prevState) => ({
                ...prevState,
                classId: profileData.classId || "",
                category: profileData.category || "",
                // qualification_completion_year: profileData.qualification_completion_year || "",
                qualification_completion_year:
    profileData.qualification_completion_year ||
    new Date().getFullYear().toString(),
                qualification_name: profileData.qualification_name || "",

            }));
        }
    }, [profileData]);
    
    // const handleFormDataNEW = (input) => (eventOrOption) => {
    //     let value;

    //     if (eventOrOption && eventOrOption.target) {
    //         // Handling input type="date"
    //         value = eventOrOption.target.value;
    //     } else if (eventOrOption && eventOrOption.value !== undefined) {
    //         // Handling react-select
    //         value = eventOrOption.value;
    //     }

    //     console.log(`Updating ${input} with value:`, value);

    //     setFormData((prevState) => ({
    //         ...prevState,
    //         [input]: value,
    //     }));
    // };

    const handleFormDataNEW = (input) => (eventOrOption) => {
        let value;

        if (eventOrOption && eventOrOption.target) {
            // input fields
            value = eventOrOption.target.value;
        } else if (eventOrOption && eventOrOption.value !== undefined) {
            // react-select
            value = eventOrOption.value;
        }

        console.log(`Updating ${input} with value:`, value);

        setFormData((prevState) => {
            // 🔥 Special handling for classId
            if (input === "classId") {
                const selectedClass = classList.find(
                    (c) => c._id === value
                );

                return {
                    ...prevState,
                    classId: value || "",
                    qualification_name: selectedClass?.education_type || "",
                };
            }

            // default behavior
            return {
                ...prevState,
                [input]: value,
            };
        });
    };

    const FormOneSubmit = async (e) => {
        e.preventDefault();
        console.log("formData---FormOneSubmit->", formData);
        console.log("token---FormOneSubmit->", token);
        const formDataToSend = new FormData();
        if (formData.classId) formDataToSend.append("classId", formData.classId);
        if (formData.category) formDataToSend.append("category", formData.category);
        if (formData.qualification_completion_year) formDataToSend.append("qualification_completion_year", formData.qualification_completion_year);
        if (formData.qualification_name) formDataToSend.append("qualification_name", formData.qualification_name);


        if (formData.profile_img) {
            formDataToSend.append("profile_img", formData.profile_img);
        } else {
            formDataToSend.append("profile_img", "");
        }
        try {
            const response = await axios.patch(baseUrl + "user_api/profileUpdate", formDataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log("API Response:", response.data);
            nextStep();
        } catch (error) {
            console.error("Error in API call:", error);
        }
    };
    // const isFormValid = formData.classId && formData.category && formData.qualification_completion_year && formData.qualification_name;
    // const isFormValid = formData.classId && formData.category && formData.qualification_completion_year ;
    const isFormValid = formData.classId && formData.category;


    const navigate = useNavigate();

    return (
        <div>
            <section>
                <div className=" pt-5 max-w-[1300px] mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 bg-[#F2F2F2] px-4 md:px-[30px] pb-20 rounded-[20px] gap-6">
                        {/* Sidebar Section - hidden on mobile */}
                        <div className="md:mt-0 mt-6">
                            <div className="bg-[#FFFFFF] pt-[60px] p-8 rounded-[15px] h-full">
                                <div className="flex items-center justify-center pb-[50px] ">
                                    <img
                                        src="/assates/Logo__newimage.png"
                                        alt="images"
                                        className="w-[160px]"
                                    />
                                </div>
                                <div className="h-full">
                                    <div className="flex gap-2">
                                        <div className="flex flex-col items-center">
                                            <div className="bg-[#F4F4F4] w-[50px] h-[50px] flex items-center justify-center rounded-[10px]">
                                                <img src="/assates/father_name.svg" alt="images" />
                                            </div>
                                            <div className="line h-[50px] w-[2px] bg-[#E4E4E4]" />
                                        </div>
                                        <div>
                                            <h4 className="font-[700] Paragraph__etxt ">
                                                Your Details
                                            </h4>
                                            <p className="Paragraph__etxt font-[300]">
                                                Provide your details to create
                                                your profile.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex gap-2">
                                        <div className="flex flex-col items-center">
                                            <div className="bg-[#F4F4F4] w-[50px] h-[50px] flex items-center justify-center rounded-[10px]">
                                                <img src="/assates/Eduction.svg" alt="ims" />
                                            </div>
                                            <div className="line h-[50px] w-[2px] bg-[#E4E4E4]" />
                                        </div>
                                        <div>
                                            <h4 className="font-[700] Paragraph__etxt">
                                                Educational Details
                                            </h4>
                                            <p className="Paragraph__etxt font-[300]">
                                                Fill your Educational Details
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex gap-2">
                                        <div className="flex flex-col items-center">
                                            <div className="bg-[#F4F4F4] w-[50px] h-[50px] flex items-center justify-center rounded-[10px]">
                                                <i class="ri-user-location-fill text-[22px] text-[#D0D0D0]"></i>
                                            </div>
                                        </div>
                                        <div className="">
                                            <h4 className="font-[700] Paragraph__etxt">
                                                Address
                                            </h4>
                                            <p className="Paragraph__etxt font-[300]">
                                                Complete Address, City, State, Pincode
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* Form Section */}
                        <div className="pt-[70px] flex flex-col justify-between">
                            <div className="relative">
                                <button
                                    className=" absolute top-0 right-0 hover:bg-gray-300 rounded-full p-2 flex items-center justify-center w-10 h-10"
                                    onClick={() => prevStep()}
                                >
                                    <img src="/assates/left_arrow.png" alt="Back" className="w-3" />
                                </button>
                                <h3 className="Header__text font-bold">Educational Details</h3>
                                <p className="Paragraph__etxt font-medium pt-1 pb-4">
                                    Fill your Educational Details
                                </p>

                                <form onSubmit={FormOneSubmit} className="space-y-8">
                                    {/* Class & Category */}

                                    <div className="flex flex-col md:flex-row gap-4">
                                        {/* Class Select */}
                                        <div className='w-full flex flex-col gap-[2px]'>
                                            <label className='Header__text !text-[14px]'>Education Details</label>
                                            <div className="flex bg-white pl-3 rounded-[10px] items-center w-full">
                                                <div>
                                                    <img src="/assates/Eduction.svg" alt="icon" />
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <Select
                                                        options={classList.map((classItem) => ({
                                                            value: classItem._id,
                                                            label: classItem.name,
                                                        }))}
                                                        onChange={handleFormDataNEW("classId")}
                                                        value={
                                                            classList.find((c) => c._id === formData.classId)
                                                                ? {
                                                                    value: formData.classId,
                                                                    label: classList.find((c) => c._id === formData.classId).name,
                                                                }
                                                                : null
                                                        }
                                                        className="w-full"
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                padding: "10px",
                                                                borderRadius: "5px",
                                                                borderColor: "#ffffff",
                                                            }),
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Category Select */}
                                        <div className='w-full flex flex-col gap-[2px]'>
                                            <label className='Header__text !text-[14px]'>Select Category</label>
                                            <div className="flex bg-white pl-3 rounded-[10px] items-center w-full">
                                                <div>
                                                    <img src="/assates/Eduction__catures.svg" alt="icon" />
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <select
                                                        name="category"
                                                        className="w-full py-3"
                                                        style={{ outline: "none" }}
                                                        onChange={handleFormDataNEW("category")}
                                                        value={formData.category}
                                                    >
                                                        <option value="">Select Option</option>
                                                        <option value="General">General</option>
                                                        <option value="OBC">OBC</option>
                                                        <option value="SC">SC</option>
                                                        <option value="ST">ST</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Completion Year */}
                                    <div className="flex flex-col md:flex-row gap-4">
                                        <div className='w-full flex flex-col gap-[2px]'>
                                            <label className='Header__text !text-[14px]'>Education Completion Year</label>
                                            <div className="flex bg-white pl-3 rounded-[10px] items-center w-full">
                                                <div>
                                                    <img src="/assates/Date__images.svg" alt="icon" />
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <select
                                                        name="qualification_completion_year"
                                                        required
                                                        className="w-full py-3"
                                                        style={{ outline: "none" }}
                                                        onChange={(e) =>
                                                            handleFormDataNEW("qualification_completion_year")({
                                                            target: { value: e.target.value },
                                                            })
                                                        }
                                                        // Change the fallback from "" to the current year string
                                                        // value={formData.qualification_completion_year || new Date().getFullYear().toString()}
                                                        value={formData.qualification_completion_year}
                                                        >
                                                        <option value="" disabled>
                                                            Select Year
                                                        </option>
                                                        {Array.from({ length: 201 }, (_, i) => {
                                                            const startYear = new Date().getFullYear() - 100;
                                                            const year = startYear + i;
                                                            return (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='w-full flex flex-col gap-[2px]'>
                                            <label className='Header__text !text-[14px]'>Education/Degree Type</label>
                                            <div className="flex bg-white pl-3 rounded-[10px] items-center w-full">
                                                <div>
                                                    <img src="/assates/Eduction__catures.svg" alt="icon" />
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    {/* <select*/}
                                                    {/*    className="w-full py-3"*/}
                                                    {/*    style={{ outline: "none" }}*/}
                                                    {/*    onChange={handleFormDataNEW("qualification_name")}*/}
                                                    {/*    value={formData.qualification_name}*/}
                                                    {/*>*/}
                                                    {/*    <option value="">Select Option</option>*/}
                                                    {/*    <option value="Matriculation">Matriculation </option>*/}
                                                    {/*    <option value="12 th">12 th</option>*/}
                                                    {/*    <option value="Graduation">Graduation </option>*/}
                                                    {/*</select>*/}

                                                    <input
                                                        type="text"
                                                        name="qualification_name"
                                                        className="w-full py-3"
                                                        value={formData.qualification_name || ""}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Submit Button */}
                                    <div className="flex justify-end">
                                        <button
                                            type="submit"
                                            className={`w-full max-w-[350px] h-[50px] rounded-[15px] text-white Paragraph__etxt ${isFormValid ? "bg-gray-900" : "bg-[#B4B4B4]"
                                                }`}
                                        >
                                            Continue
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default FormThree;
